module.exports = __webpack_public_path__ + "img/icon-card.034f23b1.png";